import { render, staticRenderFns } from "./listType.vue?vue&type=template&id=72cff78c"
import script from "./listType.vue?vue&type=script&lang=js"
export * from "./listType.vue?vue&type=script&lang=js"
import style0 from "./listType.vue?vue&type=style&index=0&id=72cff78c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports